import React, { useRef } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import "../../scss/sticky.scss";
const BeverageTable = ({ beverage, beveragesum, totalbeveragequantity }) => {
  const tableRef = useRef(null);
  return (
    <div className="flex flex-col">
      <div className="table-responsive-beverage">
        <div className="table-responsive-food-header">
          <div className="bg-heading-food">
            <h4 className="beverage-heading">Beverage</h4>
          </div>
          <DownloadTableExcel
            filename="beverages_table"
            sheet="beverages"
            currentTableRef={tableRef.current}>
            <button className="export"> Export </button>
          </DownloadTableExcel>
        </div>
        <div className="table-responsive" ref={tableRef}>
          <table className="table-beverage">
            <tr className="sticky-header">
              <th>S.N</th>
              <th>Group</th>
              <th>Item Name </th>
              <th>Item Rate (Rs)</th>
              <th>Quantity</th>
              <th>Total(Rs)</th>
            </tr>
            {!beverage?.error &&
              beverage.map((item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{item.Description}</td>
                  <td>{item.ItemName}</td>
                  <td>{item.itemRate}</td>
                  <td>{item.count}</td>
                  <td>{item.Total}</td>
                </tr>
              ))}
          </table>
        </div>
      </div>
    </div>
  );
};

export default BeverageTable;
